import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=5bdb90f4&scoped=true&"
import script from "./ControlBar.vue?vue&type=script&lang=js&"
export * from "./ControlBar.vue?vue&type=script&lang=js&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=5bdb90f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb90f4",
  null
  
)

export default component.exports